// extracted by css-extract-rspack-plugin
export default {"container":"LeadingBadge-module__container__CoDCEbG","titleLabel":"LeadingBadge-module__titleLabel__bbGF84x","titleText":"LeadingBadge-module__titleText__WSTuNPK"};